import loadMaps from './modules/loadMaps';
import mapStyles from './modules/mapStyles';


export default () => {
  const node = document.querySelector('[data-control="isocomHQMap"]');

  if (! node) {
    return;
  }

  loadMaps(() => {
    isocomhq(node);
  });
};

const isocomhq = (node) => {
  const { Map, InfoWindow, Marker, ControlPosition } = google.maps;
  const isocomhq = JSON.parse(node.dataset.isocomhq || '[]');

  const infoWindow = new InfoWindow();
  const map = new Map(node, {
    styles: mapStyles,
    zoom: 7,
    minZoom: 5, maxZoom: 15,
    mapTypeControl: false,
    streetViewControl: false,
    signInControl: false,
    scrollwheel: false,
    fullscreenControl: false,
    clickableIcons: false,
    center: { lat: 54.9023195, lng: -1.5542285999999876 },
    zoomControlOptions: { position: ControlPosition.RIGHT_TOP },
  });

  isocomhq.forEach((place, idx) => {

    const marker = new Marker({
      ...markerImage(place),
      map: map,
      title: place.name,
      zIndex: idx,
      optimized: false,
      position: {
        lat: parseFloat(place.location.latitude),
        lng: parseFloat(place.location.longitude),
      },
    });

    addMapListener(marker, 'click', () => {
      infoWindow.setContent(`
        <div id="popUp">
          <div id="bodyContent">
            <p class="distributionMap__title">${place.title}</p>
            <p class="distributionMap__address">${place.address}</p>
            <p class="distributionMap__contact">Telephone: <a href="tel:${place.telephone}">${place.telephone}</a><br>Email: <a href="mailto:${place.email}">${place.email}</a></p>
          </div>
        </div>
      `);

      infoWindow.open(map, marker);
    });
  });

  addMapListener(map, 'click', () => {
    infoWindow.close();
  })
};

const markerImage = (place) => ({
  icon: {
    url: place.type === 'one' ? `/themes/app/assets/images/googlemap/map_marker_blue.svg` : `/themes/app/assets/images/googlemap/map_marker_orange.svg`,
    scaledSize: new google.maps.Size(22, 31),
  }
});

const addMapListener = (target, event, callback) =>
  google.maps.event.addListener(target, event, callback);



// WEBPACK FOOTER //
// ./themes/app/assets/js/isocomHQMap.js